import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import WebLiteServerInfo from "./WebLiteServerInfo";

const WebLiteServerList = ({ currentPage, list_liteServer, handleSelectedFunc }) => {
    const { t } = useTranslation();

    return (
        <div className="d-flex flex-column w-100 my-2">
            {
                // teacher/class, 로컬 서버 관리 화면과 동일한 table-container / list-table 스타일 (내용·데이터 흐름은 동일)
                list_liteServer && list_liteServer.length > 0 ?
                    <div className="table-container">
                        {/* 260804-7 사이트/서버 이름 말줄임(...) 실제 동작을 위해 table-layout:fixed 적용 */}
                        {/* 20260828 로컬 서버 관리 화면과 동일한 구조로 재배치 - Memo/IP는 상세설정·상세정보 패널로 이동 */}
                        <table className="list-table admin-ellipsis-table">
                            <thead>
                                {/* 20260828 이름 편집 입력창+버튼이 잘리지 않도록 Name 컬럼 폭을 넓히고, 로컬 서버 화면과 비율을 맞춰 나머지 컬럼 폭을 조정 */}
                                <tr>
                                    {/* 20260828 다국어 키로 통일: No. -> 순번, Name -> 이름 */}
                                    <th style={{ width: '7%' }} className="text-center">{t("순번", { ns: "admin" })}</th>
                                    <th style={{ width: '15%' }} className="text-center">{t("Local_Site", { ns: "admin" })}</th>
                                    <th style={{ width: '39%' }} className="text-center">{t("이름", { ns: "admin" })}</th>
                                    <th style={{ width: '19%' }} className="text-center">{t("Auth_Code", { ns: "admin" })}</th>
                                    <th style={{ width: '20%' }} className="text-center" />
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    list_liteServer.map((liteServer, idx) => (
                                        <WebLiteServerInfo
                                            // 20260828 페이지 이동 시 상세정보/상세설정 펼침 상태가 남지 않도록 currentPage를 key에 포함 (로컬 서버 관리 화면과 동일)
                                            key={`config-lite-local-${currentPage}-${idx}`}
                                            idx={idx}
                                            liteServer_info={liteServer}
                                            handleSelectedFunc={handleSelectedFunc}
                                        />
                                    ))
                                }
                            </tbody>
                        </table>
                    </div> :
                    <div className="d-flex view m-3 justify-content-center grey-text" style={{ fontSize: '1rem' }}>
                        {t("관리_가능한_로컬_서버_목록_없음", { ns: "admin" })}
                    </div>
            }
        </div>
    );
}

export default WebLiteServerList;